

export type IndexDeploymentMode =
    "Parallel"
    | "Rolling";